import React from "react";
import LegalNotices from "../../components/LegalNotices/LegalNotices";

const Legal = () => {
    return (
        <div className="legal-container">
            <div>
                <LegalNotices />
            </div>

        </div>
    );
};

export default Legal;